/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-bottom': {
    width: 10,
    height: 7,
    viewBox: '0 0 10 7',
    data: '<path pid="0" d="M1.663 1.172a.867.867 0 00-1.26 1.19l3.684 3.9a.867.867 0 001.26 0l3.683-3.9a.867.867 0 00-1.26-1.19L4.717 4.404 1.663 1.172z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
